import axios from "./axios"

class Get {
  async send(payload) {
    return axios()
      .post("/api/adb/cmd", payload)
      .catch(err => _$.error(err))
  }
}

export default new Get()
